import React, { FC } from "react";

import DailyCheckIn from "../../../components/DailyCheckIn/DailyCheckIn";
import HomeHospitalContainer from "../../../components/HomeHospital/HomeHospitalContainer";

type IRightPanelProps= {
  setHospitalDetailsContent?: (content: any) => void;
}

const RightPanelContainer: FC<IRightPanelProps> = (props) => {
  const { setHospitalDetailsContent } = props;

  return (
    <>
      <DailyCheckIn />
      <HomeHospitalContainer setHospitalDetailsContent={setHospitalDetailsContent}/>
    </>
  );
};

export default RightPanelContainer;
